import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class NormalWin implements SimplePresentation {

    name:string = "NormalWin";

    shouldRun():boolean {
        return FlightMode.model.anyWinningSymbols();
    }

    start(controller:SimplePresentationRunnerController):void {
        const winRatio = FlightMode.model.responseWinRatio;
        const tl = gsap.timeline();

        const hackjob:gsap.core.Timeline[] = [];
        const garbage = {timeScale:1};

        tl.add(() => {
            //controller.setSkipCallback(() => {tl.progress(1, false)})
            controller.setSkipCallback(() => {
                garbage.timeScale = 2;
                hackjob.forEach((bruh) => bruh.timeScale(bruh.timeScale() * 2));
                tl.timeScale(2);
            })
        })

        tl.add(FlightMode.reelView.getAllSymbols().map((sym) => sym.setNoWin()), '>0.1');


        FlightMode.model.getWins()
            .slice()
            .sort((a,b) => b.winLineData.multipliedAmount - a.winLineData.multipliedAmount)
            .forEach((win, index) => {
                const blinkTl = gsap.timeline();
                const blinkSymbols = win.winningPositions
                    .map((pos) => FlightMode.reelView.getSymbolAt(pos.reel, pos.row));

                const finalPosition = win.winningPositions[win.winningPositions.length - 1];
                const killmelol = FlightMode.winView.showIndividualWin(
                    win.winLineData.amount,
                    win.winLineData.multiplier,
                    win.winLineData.numberOfCombinations,
                    finalPosition.reel,
                    finalPosition.row
                );
                hackjob.push(killmelol);
                killmelol.timeScale(0);
                blinkTl.add(() => {
                    killmelol.timeScale(garbage.timeScale);
                });
                blinkTl.add(blinkSymbols.map((sym) => sym.getWinAnimation(winRatio)), '<')
                blinkTl.add(() => {
                    if (index == 0)
                        FlightMode.soundPlayer.playLoopingSound("symShake");
                    FlightMode.soundPlayer.playSound("winBlink");
                }, '<')
                tl.add(blinkTl, '>0.2');
            })

        tl.add(FlightMode.reelView.getAllSymbols().map((sym) => sym.setNormal()), '>0.5');

        tl.add(() => {
            FlightMode.updateKeypadWin();
            controller.finish()
        });
    }
}